import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {Terminals} from "../../../shared/interface/terminals";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {TerminalsService} from "../../../shared/services/terminals.service";
import {
  ChangeTerminalsImportRowDialogComponent
} from "../change-terminals-import-row-dialog/change-terminals-import-row-dialog.component";
import {
  DictService, TERMINAL_STATUS,
  TERMINAL_STATUS_PAID, TERMINAL_STATUS_SUSPENDED,
  TERMINAL_STATUS_TO_BE_REALIZED,
} from "../../../shared/services/dict.service";
import {
  ConfirmDialogWithReasonComponent
} from "../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";
import {HttpErrorResponse} from "@angular/common/http";
import {TerminalsNoteAddComponent} from "../terminals-note-add/terminals-note-add.component";
import {Dictionary} from "../../../shared/interface/dictionary";

@Component({
  selector: 'app-terminals-details-view',
  templateUrl: './terminals-details-view.component.html',
  styleUrls: ['./terminals-details-view.component.scss']
})
export class TerminalsDetailsViewComponent  implements OnInit, OnDestroy {
  @Input() terminals: Observable<Terminals>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() modifyClickedEdit = new EventEmitter<any>();

  readonly TERMINAL_STATUS_TO_BE_REALIZED = TERMINAL_STATUS_TO_BE_REALIZED;
  readonly TERMINAL_STATUS_PAID = TERMINAL_STATUS_PAID;
  readonly TERMINAL_STATUS_SUSPENDED = TERMINAL_STATUS_SUSPENDED;

  terminalsObject?: Terminals;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private terminalsService: TerminalsService,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.terminals
      .pipe(takeUntil(this.destroyed$))
      .subscribe((terminals: Terminals) => {
        this.terminalsObject = terminals;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć polisę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.terminalsService.delete(this.terminalsObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto polisę', '', {duration: 2000});
            this.router.navigate(['/terminale/polisy/lista']);
          });
      }
    });
  }

  terminalImportRowChange(): void {
    const dialogRef = this.dialog.open(ChangeTerminalsImportRowDialogComponent, {
      width: '700px',
      data: {
        terminalsObject: this.terminalsObject
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.modifyClicked.emit();
    });
  }


  modify(): void {
    this.modifyClickedEdit.emit();
  }

  statusChange(statusKey: string): void {
    this.dictService.get(statusKey, TERMINAL_STATUS)
      .subscribe((dict: Dictionary) => {
        let statusName = '';
        if (dict.key === this.TERMINAL_STATUS_PAID){
          statusName = 'Zapłacona';
        } else {
          statusName = dict.name;
        }

        const textValue = 'Czy na pewno chcesz zmienić status polisy na \'' + statusName + '\'?';
        let dialogComponent;
        if (dict.key === this.TERMINAL_STATUS_TO_BE_REALIZED){
          dialogComponent = ConfirmDialogComponent;
        } else {
          dialogComponent = ConfirmDialogWithReasonComponent;
        }

      const dialogRef = this.dialog.open(dialogComponent, {
        width: '500px',
        data: {text: textValue},
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.accepted === true || result === true) {
          let reason: string = null;
          if (dict.key !== this.TERMINAL_STATUS_TO_BE_REALIZED){
            reason = result.reason;
          }
          this.terminalsService.statusChange(this.terminalsObject.uuid , dict.id, reason)
            .subscribe({
              next: () => {
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
                this.modifyClicked.emit();
              },
              error: (response: HttpErrorResponse) => {
                this.snack.open(response.error.error.text, response.status.toString(), {duration: 2000});
              }
            });
        }
      });
    });
  }

  addNote(): void {
    const dialogRef = this.dialog.open(TerminalsNoteAddComponent, {
      width: '700px',
      data: {
        terminals: this.terminalsObject},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.modifyClicked.emit();
    });
  }
}

